import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles/index';
import {
  AppBar,
  Paper, Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow, Toolbar,
  Typography
} from '@material-ui/core';
import classNames from 'classnames';
import * as Actions from 'auth/store/actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
//import { Link } from 'react-router-dom';
import _ from 'lodash';
import {API} from "../../../config";
import Document from "../isinApplications/components/UploadDocument";
const m = require('moment-timezone');

const fileRequest = API.service('file-request');
const uploadedFiles = API.service('uploaded-files');

const styles = theme => ({
  root: {
    background: "url('/assets/images/backgrounds/city_street.png') no-repeat",
    backgroundSize: 'cover'
  },
  intro: {
    color: '#ffffff'
  },
  card: {
    width: '100%',
    maxWidth: 400
  }
});

class FileRequestUpload extends Component {
  state = {
    upload_request:{
      active  : false,
    },
    loaded    : false,
    docs: [],
    complete: false
  };

  componentDidMount() {
    if(typeof this.props.match.params.requestId !== "undefined"){
      fileRequest.find({query:{request_uuid:this.props.match.params.requestId,$limit:1}}).then(r=>{
        if(r.total === 1){
          let fr = r.data[0];
          let expiry = fr.expiry
          let expired = m(expiry).endOf('day').diff(m());
          console.log(m(expiry).endOf('day').diff(m()))
          if(fr.active !== 0 && expired < 0){
            fr.active = false;
          }

          fr.expired = Math.floor(m.duration(m(expiry).endOf('day').diff(m())).as('days'));
          //Have any files already been uploaded to this request?
          uploadedFiles.find({query:{request_id: fr.request_uuid}}).then(d=>{
            let docs = [];
            if(d.total >= 1 && fr.multifile === 0){
              fr.active = false;
            } else {
              docs = d.data;
            }

            this.setState({
              upload_request: fr,
              loaded: true,
              docs: docs,
            })
          })
        } else {
          this.setState({
            upload_request: {active: false},
            loaded: true,
          })
        }
      })
    }
  }

  handleChange = (event) => {
    this.setState(_.set({ ...this.state }, event.target.name, event.target.type === 'checkbox' ? event.target.checked : event.target.value));
  };

  canBeSubmitted() {
    const { email, password } = this.state;
    return (
      email.length > 0 && password.length > 0
    );
  }

  submit = (e) => {
    e.preventDefault();

    var controller = this;

    controller.setState({
      error: false
    })
  }

  updateInbound = (doc_id) => {
    let docs = this.state.docs;
    let complete = false;
    docs.push(doc_id);
    if(this.state.upload_request.multifile === 0){
      complete = true;
    }
    this.setState({
      docs:docs,
      complete:complete
    })
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classNames(classes.root, "flex flex-col flex-auto flex-no-shrink items-center justify-center")}>

        <Paper className="flex flex-col items-center justify-center w-1/3">
          <AppBar position={'static'} className={'flex'} elevation={0} color={"default"}>
            <Toolbar>
              <div style={{flexGrow:1}}><img className="m-16" style={{ width: '220px' }} src="assets/DCSX.png" alt="logo" /></div>
              <div><Typography variant="title">File Upload Request</Typography></div>
            </Toolbar>
          </AppBar>
          <div className={'p-24'}>
            {(typeof this.props.match.params.requestId === "undefined") &&
              <div>
                No Request Specified
              </div>
            }

            {(this.state.upload_request.request_uuid === this.props.match.params.requestId) &&
              <React.Fragment>
                {(typeof this.props.match.params.requestId !== "undefined" && this.state.complete === false &&  this.state.upload_request.active !== false) &&
                <div style={{position:'relative'}}>
                  <Typography className={'py-24'}>{this.state.upload_request.description}</Typography>

                  <Document type={'isin-document'}
                            label='Upload Document'
                            assoc_id={this.state.upload_request.assoc_id}
                            placeholder='/bill.jpg'
                            request_id={this.state.upload_request.request_uuid}
                            onComplete={this.updateInbound}
                            hideReviewStatus={true}
                  />

                  <Typography className={'pb-24'}>This request expires in {m.duration(m(this.state.upload_request.expiry).endOf('day').diff(m())).humanize(true)}</Typography>


                  {(this.state.upload_request.multifile === true) &&
                  <React.Fragment>
                    <Typography variant="heading1">The following files have currently been uploaded as part of this
                      request:</Typography>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>Filename</TableCell>
                          <TableCell>Uploaded At</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {(this.state.docs.length >= 0) &&
                        <React.Fragment>
                          {this.state.docs.map((v, i) => {
                            return (
                                <TableRow>
                                  <TableCell>{v.orig_filename}</TableCell>
                                  <TableCell
                                      style={{textTransform: 'capitalize'}}>{m(v.createdAt).format('LLL')}</TableCell>
                                </TableRow>
                            )
                          })}
                        </React.Fragment>
                        }
                      </TableBody>
                    </Table>
                  </React.Fragment>
                  }
                </div>
                }
            </React.Fragment>
            }

            {(typeof this.props.match.params.requestId !== "undefined" && this.state.complete === false && this.state.loaded === true && this.state.upload_request.active === false) &&
              <div>
                <b>File Request Closed or Invalid</b><br/>
                Please contact DCSX Administration
              </div>
            }

            {(this.state.complete === true) &&
            <div>
              <b>Thank you for uploading the required file</b><br/>
              If you have any further queries please contact DCSX Administration
            </div>
            }
          </div>

        </Paper>
      </div>
    );
  }

}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    setUserData: Actions.setUserData
  }, dispatch);
}

function mapStateToProps({ fuse, auth }) {
  return {
    login: auth.login,
    user: auth.user
  }
}

export default withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(FileRequestUpload));



// WEBPACK FOOTER //
// ./src/main/content/fileRequest/FileRequestUpload.js